import { useRef, useState } from "react";

export default function BeforeAfter({ before, after }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const updatePos = (clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const x = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, x)));
  };

  return (
    <div
      ref={ref}
      className="ba-container aspect-[3/2] w-full bg-[#EBE8E0]"
      onMouseDown={(e) => { dragging.current = true; updatePos(e.clientX); }}
      onMouseMove={(e) => dragging.current && updatePos(e.clientX)}
      onMouseUp={() => (dragging.current = false)}
      onMouseLeave={() => (dragging.current = false)}
      onTouchStart={(e) => { dragging.current = true; updatePos(e.touches[0].clientX); }}
      onTouchMove={(e) => dragging.current && updatePos(e.touches[0].clientX)}
      onTouchEnd={() => (dragging.current = false)}
      data-testid="before-after-slider"
    >
      <img
        src={before}
        alt="Before restoration"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ objectPosition: "50% 40%" }}
        draggable={false}
      />
      <div className="ba-after" style={{ width: `${pos}%` }}>
        <img
          src={after}
          alt="After restoration"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ width: `${(100 / pos) * 100}%`, maxWidth: "none", objectPosition: "50% 40%" }}
          draggable={false}
        />
      </div>
      <div className="ba-handle" style={{ left: `${pos}%` }} />
      <div className="absolute top-4 left-4 bg-black/60 text-white px-3 py-1 text-xs tracking-widest uppercase">
        Before
      </div>
      <div className="absolute top-4 right-4 bg-[#3F5746] text-white px-3 py-1 text-xs tracking-widest uppercase">
        After
      </div>
    </div>
  );
}
